import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: false,
  details: {},
  blogs: [],
  loading: false,
  categories: [],
  data: [],
  category:[],
  myBlog:[], 
  very:[]
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    getBlogSuccess: (state, action) => {
      state[action.payload.url] = action.payload.apiData;
    },
    getOneBlogSuccess: (state, { payload }) => {
      state.data = payload.data;
    },
    getCategory: (state, action) => {
      state.category = action.payload.apiData;
    },
    myBlogSuccess: (state, action) => {
      state.myBlog = action.payload.data;
    },
    getDataSuccess:(state,action)=>{
      state.very=action.payload
    }
  },
});

export const {getDataSuccess, myBlogSuccess,getBlogSuccess, getOneBlogSuccess, getCategory } =
  blogSlice.actions;

export default blogSlice.reducer;
